import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { saveSingle } from "../../services/privateAccountService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Table } from "semantic-ui-react";
import TableTitle from "../common/tableTitle";
import { Link } from "react-router-dom";

class PrivateAccountForm extends Form {
  state = {
    show_in_ledger_when_close_options: [
      { id: "", name: "Select option" },
      { id: 1, name: "Yes" },
      { id: 0, name: "No" },
    ],
    data: {
      passport_number: "",
      identification_id: "",
      mobile: "",
      name: "",
      email_address: "",
      show_in_ledger_when_close: "",
    },
    errors: {},
  };

  schema = {
    id: Joi.string(),
    passport_number: Joi.string().required().label("Company Name"),
    identification_id: Joi.string().allow("").label("Emirates ID"),
    mobile: Joi.string().required().label("Mobile"),
    name: Joi.string().required().label("Name"),
    email_address: Joi.string().allow("").label("Email Address"),
    show_in_ledger_when_close: Joi.string()
      .allow("")
      .label("show in ledger when close option"),
  };

  doSubmit = async () => {
    try {
      this.setState({ blocking: true });

      const data = { ...this.state.data };
      data.account_type = document.getElementById("account_type").value;

      await saveSingle(data);
      toast.success("Account has been added successfully.");
      this.setState({ blocking: false });
      this.props.history.push("/private-accounts");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.passport_number)
          errors.passport_number = ex.response.data.errors.passport_number;

        if (ex.response.data.errors.identification_id)
          errors.identification_id = ex.response.data.errors.identification_id;

        if (ex.response.data.errors.mobile)
          errors.mobile = ex.response.data.errors.mobile;

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  render() {
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Add account</h1>
        <button
          className="btn btn--secondary"
          onClick={() => this.props.history.push("/private-accounts")}
        >
          Back
        </button>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Add account</h3>
              <p>Provide the information below to add the account.</p>
              {this.renderInput("passport_number", "Company Name", "text")}
              {this.renderInput("identification_id", "Emirates ID", "text")}
              {this.renderInput("mobile", "Mobile", "text")}
              {this.renderInput("name", "Name", "text")}
              {this.renderInput("email_address", "Email Address", "text")}

              <label>Account Type</label>
              <select name="account_type" id="account_type" className="input">
                <option value="">Select type</option>
                <option value="jv">JV</option>
                <option value="scrap">SCRAP</option>
              </select>
              <br />
              <br />

              {this.renderSelect(
                "show_in_ledger_when_close",
                "Show in ledger when close",
                this.state.show_in_ledger_when_close_options
              )}

              {this.renderButton("Save")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default PrivateAccountForm;
